import { findIndex } from 'lodash';
import { isArray, l } from 'src/utils/helper';

const mock = {};

export default {
  set(key, value) {
    mock[key] = value;
  },
  push(key, value) {
    if (!isArray(mock[key])) {
      l.warn(`значения в кэше с ключом ${key} не являются массивом. Лучше использовать сначала set метод`);
      mock[key] = [];
    }
    return mock[key].push(value);
  },
  remove(key) {
    delete mock[key];
  },
  removeByTemporaryId(key, temporaryId) {
    if (isArray(mock[key])) {
      const index = findIndex(mock[key], (item) => item.temporaryId === temporaryId);
      mock[key].splice(index, 1);
    }
  },
  get(key) {
    return mock[key];
  },
  clear() {
    if (mock) {
      Object.keys(mock).forEach((key) => {
        delete mock[key];
      });
    }
  },
};
